import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';

import { PhotoEstimationLinkState } from '@app/data/state';

export const linkValidGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  if (store.selectSnapshot(PhotoEstimationLinkState.isValid)) {
    return true;
  }
  return router.createUrlTree(['/']);
};
